const links = [...document.querySelectorAll('.js-pagination-link')];

function addToUrl() {
  links.forEach((link) => {
    const url = new URL(link.href);
    for (let [k, v] of new URLSearchParams(window.location.search).entries()) {
      if (!url.searchParams.get(k)) {
        url.searchParams.set(k, v);
      }
    }
    link.href = url.toString();
  });
}

function init() {
  if (!links.length) {
    return;
  }

  addToUrl();
}

export default init;
